<template>
  <div class="recharge_wrap add-account-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('account.addAccount') }}
      </div>
    </div>

    <section class="form-card">
      <div class="field-item">
        <div class="field-label">
          {{ $t('account.bank') }}
        </div>
        <van-dropdown-menu class="wallet-menu">
          <van-dropdown-item
            v-model="value"
            :options="wallets"
            @change="onChange"
          />
        </van-dropdown-menu>
      </div>

      <div v-show="bank.type == 1">
        <div class="field-item">
          <div class="field-label">
            {{ $t('account.address') }}:
          </div>
          <input
            v-model="bank.account"
            class="inputView"
            type="text"
            :placeholder="$t('account.addressTit')"
          >
        </div>
      </div>

      <div
        v-show="bank.type == 4"
        class="list_wrap"
      >
        <div class="listItem">
          <div class="label">
            {{ $t('invest_bank.bank') }}
          </div>
          <input
            v-model="bank.area"
            class="inputView"
            type="text"
            :placeholder="$t('invest_bank.bankin')"
          >
        </div>
        <div class="listItem">
          <div class="label">
            {{ $t('invest_bank.name') }}
          </div>
          <input
            v-model="bank.name"
            class="inputView"
            type="text"
            :placeholder="$t('invest_bank.namein')"
          >
        </div>
        <div class="listItem">
          <div class="label">
            {{ $t('invest_bank.account') }}
          </div>
          <input
            v-model="bank.account"
            class="inputView"
            type="text"
            :placeholder="$t('invest_bank.accountin')"
          >
        </div>
      </div>
    </section>

    <button
      type="button"
      class="basic_btn"
      @click="submitBtn"
    >
      {{ $t('account.submit') }}
    </button>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import {
	DropdownMenu,
	DropdownItem,
} from "vant";

Vue.use(DropdownMenu).use(DropdownItem);

export default {
	name: "AddcountUsdt",
	data() {
		return {
			bank: {
				account: "",
				name: "",
				area: "",
				bank: "",
				img: "",
				type: 1,
				wid: 0,
			},
			fileList: [],
			type: 1,
			value: 0,
			wallets: [],
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			Fetch("/user/wallet_type", {}).then(r => {
				var list = r.data || [];

				if (!list.length) {
					return;
				}

				this.bank.bank = list[0].name;
				this.bank.type = list[0].type;
				this.bank.wid = list[0].id;
				for (var i = 0; i < list.length; i++) {
					this.wallets.push({
						text: list[i].name,
						value: i,
						type: list[i].type,
						wid: list[i].id,
					});
				}
			});
		},
		submitBtn() {
			Fetch("/user/bank_add", {
				...this.bank,
			}).then(() => {
				this.$router.go(-1);
			});
		},
		onChange() {
			var selected = this.wallets[this.value];

			if (!selected) {
				return;
			}

			this.type = selected.type;
			this.bank.bank = selected.text;
			this.bank.type = selected.type;
			this.bank.wid = selected.wid;
		},
	},
};
</script>

<style lang="less" scoped>
.add-account-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 88px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #16223a;
	}
}

.form-card {
	margin: 16px 16px 0;
	padding: 4px 16px 18px;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.field-item,
.listItem {
	padding-top: 14px;
}

.field-label,
.label {
	margin-bottom: 8px;
	color: #6d7688;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
}

.inputView {
	width: 100%;
	height: 44px;
	border: 1px solid rgba(255, 93, 122, 0.32);
	border-radius: 10px;
	background: #fff6f8;
	color: #16223a;
	font-size: 14px;
	line-height: 20px;
	padding: 0 12px;
	box-sizing: border-box;
	outline: none;
}

.inputView::placeholder {
	color: #727d91;
}

.inputView:focus {
	border-color: rgba(255, 93, 122, 0.52);
	box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.1);
}

.inputView:-webkit-autofill,
.inputView:-webkit-autofill:hover,
.inputView:-webkit-autofill:focus {
	-webkit-text-fill-color: #16223a;
	box-shadow: 0 0 0 1000px #fff6f8 inset;
	caret-color: #ff5d7a;
}

.basic_btn {
	width: calc(100% - 32px);
	height: 46px;
	margin: 24px 16px 0;
	border: 1px solid rgba(255, 93, 122, 0.42);
	border-radius: 10px;
	background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
	color: #fff;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/deep/ .van-dropdown-menu__bar {
	width: 100%;
	height: 44px;
	box-shadow: none;
	border: 1px solid rgba(255, 93, 122, 0.32);
	border-radius: 10px;
	background: #fff6f8;
	box-sizing: border-box;
}

/deep/ .wallet-menu .van-dropdown-menu__item {
	justify-content: flex-start;
	padding: 0 16px;
	box-sizing: border-box;
}

/deep/ .wallet-menu .van-dropdown-menu__title {
	width: 100%;
	padding: 0 18px 0 0;
	color: #16223a;
	font-size: 14px;
	text-align: left;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/deep/ .wallet-menu .van-dropdown-menu__title::after {
	right: 2px;
	border-color: transparent transparent #ff5d7a #ff5d7a;
}

/deep/ .van-dropdown-item--down {
	left: 32px !important;
	right: auto !important;
	width: calc(100% - 64px) !important;
	overflow: visible;
}

/deep/ .van-dropdown-item__content {
	width: 100%;
	border: 1px solid rgba(255, 93, 122, 0.32);
	border-top: 0;
	border-radius: 0 0 10px 10px;
	overflow: hidden;
	box-sizing: border-box;
}

/deep/ .van-popup {
	background: #fff;
}

/deep/ .van-cell {
	background: #fff;
	color: #16223a;
}

/deep/ .van-cell:not(:last-child)::after {
	border-bottom-color: rgba(255, 255, 255, 0.06);
}

/deep/ .van-dropdown-item__option--active,
/deep/ .van-dropdown-item__icon {
	color: #ff5d7a;
}

@media screen and (max-width: 374px) {
	.form-card {
		margin-right: 12px;
		margin-left: 12px;
		padding-right: 14px;
		padding-left: 14px;
	}

	.basic_btn {
		width: calc(100% - 24px);
		margin-right: 12px;
		margin-left: 12px;
	}

	/deep/ .van-dropdown-item--down {
		left: 26px !important;
		width: calc(100% - 52px) !important;
	}
}
</style>
